export default rendererMode => {
    return {
        playerStyling: rendererMode === null ? {
            'pointerEvents': 'none'
        } : {}
        // baseStyling: rendererMode === null ? { pointerEvents: 'none' } : {}
    }
};